import { TypedDocumentNode, gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';
import { useMemo } from 'react';

import { disciplineColorForIndex } from './disciplineColors';

type DisciplineColorsData = {
    disciplines: { items: { id: string; code: string; createdAt: string }[] } | null;
};

const DISCIPLINE_COLORS_QUERY: TypedDocumentNode<DisciplineColorsData> = gql`
    query DisciplineColors {
        disciplines {
            items {
                id
                code
                createdAt
            }
        }
    }
`;

// Maps discipline code to a palette color by creation order across all of the
// org's disciplines. Ordering by createdAt keeps a discipline's color stable
// regardless of which subset a given query returns, and appending a new
// discipline never shifts existing assignments.
export const useDisciplineColorMap = (): Map<string, string> => {
    const { data } = useQuery(DISCIPLINE_COLORS_QUERY);
    return useMemo(() => {
        const items = [...(data?.disciplines?.items ?? [])].sort((a, b) =>
            a.createdAt.localeCompare(b.createdAt),
        );
        return new Map(
            items.map((discipline, index) => [discipline.code, disciplineColorForIndex(index)]),
        );
    }, [data]);
};
